import gql from 'graphql-tag';

export default ({ dummy }) => {
  return gql`
      query {
          getCcpDateTime(dummy: "${dummy || 'Hello'}") {
              ccpTime
          }
      }
  `;
};